<template>
  <div>
    <vue-modal :open="open">
    <div class="bax-modal-content bax-modal-icon-content text-center">
      <div class="bax-icon bax-remove d-flex align-items-center justify-content-center">
        <i class="icon-exclamation"></i>
      </div>
      <h2>Guidance Dose Exceeded</h2>
      <p><span v-for="(item) in this.drugs"  v-bind:key="item.drug">The dose specified for <strong>{{ item.drug }}</strong> is above our maximum guidance dose of <strong>{{ item.dosage }}</strong>. </span></p>
      <p v-if="drugs.length == 1">Is the entered dose correct?</p>
      <p v-if="drugs.length != 1">Are the entered doses correct?</p>
      <div class="bax-modal-action-items">
        <ul class="d-md-flex justify-content-center">
          <li>
            <a href="#" class="bax-btn bax-btn-gray mt-3 mt-md-0" @click.prevent="dontAddDrugToOrder">No, take me back to my order</a>
          </li>
          <li>
            <a href="#" class="bax-btn bax-btn-orange mt-3 mt-md-0" @click.prevent="addDrugToOrder">
              <span v-if="drugs.length == 1">Yes, add drug to the order</span>
              <span v-if="drugs.length != 1">Yes, add drugs to the order</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    </vue-modal>
  </div>
</template>


<script>

export default {
  name: 'ExceedDosageModal',
  props: {
    open: {
      type: Boolean,
    },
    drugs: {
      type: Array,
    },
    dosages: {
      type: Array,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    dontAddDrugToOrder() {
      this.$emit('maxDosageDenied');
    },
    addDrugToOrder() {
      this.$emit('maxDosageApproved');
    },
  },
};
</script>
